<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path
    d="M5.83366 12.083L10.0003 7.91634L14.167 12.083"
    [attr.stroke]="'var(' + color + ')'"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
